
import $ from 'jquery';

function FormLogActivity(props) {
  return (
    <form action="#" method="post" className="mt-1 mb-3 form_logactivity">
        <textarea className="form-control" name="notes" rows="3" placeholder="Notes"></textarea>
        <button type="submit" className="btn btn-primary w-100"><i className="fa fa-save me-1"></i> Submit</button>
        
        <input type="hidden" name="activity_uuid" value="" />
        <input type="hidden" name="lat" value="" className="val_pos_lat" />
        <input type="hidden" name="lng" value="" className="val_pos_lng" />
    </form>
  );
}

export function initFormLogActivity(dom) {
  
};

export default FormLogActivity;
